import React, { useState } from 'react';
import { useCart } from '../context/CartContext';

function CartItem({ item }) {
  const { updateCartItem, removeFromCart, loading } = useCart();
  const [isUpdating, setIsUpdating] = useState(false);

  const handleQuantityChange = async (newQuantity) => {
    if (newQuantity < 1) return;
    
    setIsUpdating(true);
    await updateCartItem(item.id, newQuantity);
    setIsUpdating(false);
  };

  const handleRemove = async () => {
    setIsUpdating(true);
    await removeFromCart(item.id);
    setIsUpdating(false);
  };

  return (
    <div className="cart-item">
      <div className="cart-item-image">
        <img 
          src={item.productImage || 'https://placehold.co/100x100/f0f0f0/888888?text=Auto+Part'} 
          alt={item.productName}
          onError={(e) => {
            e.target.src = 'https://placehold.co/100x100/f0f0f0/888888?text=Auto+Part';
          }}
        />
      </div>

      <div className="cart-item-details">
        <h4 className="cart-item-name">{item.productName}</h4>
        <p className="cart-item-meta">
          <span className="brand">{item.productBrand}</span>
          <span className="part-number">Part #: {item.productPartNumber}</span>
          <span className="category">{item.productCategory}</span>
        </p>
        
        <div className="cart-item-price">
          <span className="unit-price">${item.unitPrice.toFixed(2)} each</span>
        </div>

        {item.stockAvailable < 5 && item.stockAvailable > 0 && (
          <div className="stock-warning">
            Only {item.stockAvailable} left in stock
          </div>
        )}
      </div>

      <div className="cart-item-controls">
        <div className="quantity-controls">
          <button
            onClick={() => handleQuantityChange(item.quantity - 1)}
            disabled={loading || isUpdating || item.quantity <= 1}
            className="quantity-btn"
          >
            -
          </button>
          
          <input
            type="number"
            value={item.quantity}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              if (value > 0 && value <= item.stockAvailable) {
                handleQuantityChange(value);
              }
            }}
            disabled={loading || isUpdating}
            min="1"
            max={item.stockAvailable}
            className="quantity-input"
          />
          
          <button
            onClick={() => handleQuantityChange(item.quantity + 1)}
            disabled={loading || isUpdating || item.quantity >= item.stockAvailable}
            className="quantity-btn"
          >
            +
          </button>
        </div>

        <div className="cart-item-subtotal">
          <strong>${item.subtotal.toFixed(2)}</strong>
        </div>

        <button
          onClick={handleRemove}
          disabled={loading || isUpdating}
          className="remove-btn"
          title="Remove from cart"
        >
          ×
        </button>
      </div>

      {isUpdating && (
        <div className="cart-item-overlay">
          <div className="updating-spinner">Updating...</div>
        </div>
      )}
    </div>
  );
}

export default CartItem;